import { render, staticRenderFns } from "./SectionDocumentMetaData.vue?vue&type=template&id=52053dfc&scoped=true"
import script from "./SectionDocumentMetaData.vue?vue&type=script&lang=ts"
export * from "./SectionDocumentMetaData.vue?vue&type=script&lang=ts"
import style0 from "./SectionDocumentMetaData.vue?vue&type=style&index=0&id=52053dfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52053dfc",
  null
  
)

export default component.exports